import React from 'react';

function NotFound(): JSX.Element {
  return <h2>404 - Not Found</h2>;
}

export default NotFound;
